export default __webpack_public_path__ + "static/media/example2.0be01fa3.gif";